/**
 * Génère le chemin vers la documentation HTML d'une unité logique
 * @param logicalUnitCode - Code de l'unité logique (ex: "u3101")
 * @returns Chemin vers la documentation HTML (ex: "/assets/docs/u3101/index.html")
 */
export function getUserDocPath(logicalUnitCode: string): string {
  if (!logicalUnitCode) {
    return '';
  }
  
  // Normaliser le code (enlever les espaces, convertir en minuscules)
  const normalizedCode = logicalUnitCode.trim().toLowerCase();
  
  // Vérifier le format (doit commencer par 'u' suivi de chiffres)
  if (!/^u\d+/.test(normalizedCode)) {
    return '';
  }
  
  return `/assets/docs/${normalizedCode}/index.html`;
}

/**
 * Extrait le code de l'unité logique depuis un chemin de route ou un nom de module
 * @param pathOrModuleName - Chemin de route (ex: "/U3101") ou nom de module (ex: "u3101Employee")
 * @returns Code de l'unité logique (ex: "u3101") ou null si non trouvé
 */
export function extractLogicalUnitCode(pathOrModuleName: string): string | null {
  if (!pathOrModuleName) {
    return null;
  }
  
  // Pattern pour matcher u suivi de chiffres (ex: u3101, U3101)
  const match = pathOrModuleName.match(/[uU](\d+)/);
  if (match) {
    return `u${match[1]}`;
  }
  
  return null;
}
